import { Box } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

const SkeletonTile = ({ dataId }: { dataId: string }) => (
  <Box
    display="flex"
    width="full"
    flexDirection="row"
    alignItems="flex-start"
    gap="small"
    data-id={dataId}
  >
    <Box width="full">
      <Skeleton variant="text" width="100%" backgroundColor="light" />
      <Skeleton variant="text" width="60%" backgroundColor="light" />
    </Box>
  </Box>
);

export const ArticleTitleSkeleton = () => {
  return (
    <Box display="flex" width="full" gap="xsmall" flexDirection="column">
      <SkeletonTile dataId="article-title-skeleton-tile-1" />
      <SkeletonTile dataId="article-title-skeleton-tile-2" />
      <SkeletonTile dataId="article-title-skeleton-tile-3" />
    </Box>
  );
};
